import React, { Fragment } from 'react';
import DepositContent from '../../components/account/depositContent';
const Deposit = () => {
    
    return (
      <Fragment>
            <div className="title_wrap">
                <div className="title_box">
                    <div className="title">충전신청</div>
                </div>
            </div>
            <DepositContent></DepositContent>    
            
      </Fragment>
    );
};

export default Deposit;


// WEBPACK FOOTER //
// ./src/containers/Account/Deposit.js